import "./Loading.css";
import { useEffect } from "react";

export function Loading(props: any) {
    useEffect(() => {

    }, []);

    return (
        <>
            <div className="modal-loading fade-loading user-select">
                <div className="modal-dialog-loading">
                    <div className="modal-content-loading">
                        <div className="modal-dialog-bd-loading">
                            <div className="sapUiLocalBusyIndicator">
                                <div className="sapUiLocalBusyIndicatorAnimation sapUiLocalBusyIndicatorAnimStandard" title="请稍候">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}